import L from 'leaflet'
import moment from 'moment'

const domain = process.env.domain || 'http://dashboard.designerbrands.shiseido.localhost/web/'

// Routes API
export const api = {
	root: domain,
	routes: {
		csrf: 'api/generate_csrf',
		first_login: 'user/change_password',
		login: 'api/login',
		logout: 'api/logout',
		upload: 'api/import',
		options: 'api/options',
		project: 'api/project/show',
		projects: 'api/projects/list',
		new: 'api/project/new',
		edit: 'api/project/edit',
		delete: 'api/project/delete',
		refurbishment: 'api/project/renovation',
		addmessage: 'api/add/message',
		getmessages: 'api/messages',
		file: 'api/add/file',
		fileRemove: 'api/delete/file'
	},
	requestConf: {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
			// 'User-Agent': 'DBrands-front'
			// 'Authorization': this.$store.getters.token
		}
	}
}

export const iframeUrl = {
	root: domain,
	routes: {
		add: 'projects/new',
		edit: 'projects/!*ID*!/edit'
	}
}

export const colors = [
	'#c80421',
	'#F4512C',
	'#F28E00',
	'#87BC27',
	'#009FE3',
	'#555CA2',
	'#333333'
]

// map
export const tiles = {
	layer: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
	attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ'
}

export const DashboardCircleMarker = L.CircleMarker.extend({
	options: {
		data: {},
		renderer: L.canvas()
	}
})

export const tableRows = [
	{
		title: '',
		prop: 'url',
		component: 'ProjectTableGed',
		width: 60
	},
	{
		title: 'Year',
		prop: 'year',
		sortable: true,
		component: 'ProjectTableText',
		width: 60
	},
	{
		title: 'Project Name',
		prop: 'customId',
		sortable: true,
		component: 'ProjectTableText',
		width: 110
	},
	{
		title: 'Picture',
		prop: 'avatarFile',
		component: 'ProjectTableImg',
		width: 80
	},
	{
		title: 'Status',
		prop: 'projectStatus',
		component: 'ProjectSelectText',
		sortable: true,
		width: 80
	},
	{
		title: 'Brands',
		prop: 'projectBrands',
		sortable: true,
		component: 'ProjectTableBrands',
		width: 100
	},
	{
		title: 'POF Date',
		prop: 'dateOfRequest',
		component: 'ProjectTableDateText',
		sortable: true,
		width: 120
	},
	{
		title: 'Deadline Design Submission',
		prop: 'retailersSubmissionDate',
		component: 'ProjectTableDateText',
		sortable: true,
		width: 200
	},
	{
		title: 'Installation',
		prop: 'installationDate',
		component: 'ProjectTableDateText',
		sortable: true,
		width: 120
	},
	{
		title: 'Channel',
		prop: 'distributionChannel',
		component: 'ProjectSelectText',
		sortable: true,
		width: 120
	},
	{
		title: 'Area',
		sortable: true,
		prop: 'area',
		component: 'ProjectSelectText',
		width: 80
	},
	{
		title: 'Country',
		prop: 'country',
		sortable: true,
		component: 'ProjectSelectText',
		width: 120
	},
	{
		title: 'City',
		prop: 'city',
		component: 'ProjectTableText',
		sortable: true,
		width: 120
	},
	{
		title: 'Retailer',
		prop: 'retailerName',
		component: 'ProjectTableText',
		sortable: true,
		width: 120
	},
	{
		title: 'Store Name',
		prop: 'storeName',
		sortable: true,
		component: 'ProjectTableText',
		width: 160
	},
	{
		title: 'Type of Project',
		prop: 'typeOfProject.type',
		sortable: true,
		component: 'ProjectTableText',
		width: 120
	},
	{
		title: 'Type of Store',
		prop: 'typeOfStore',
		sortable: true,
		component: 'ProjectTableText',
		width: 120
	},
	{
		title: 'Budget',
		prop: 'budgetInK',
		sortable: true,
		component: 'ProjectTableText',
		width: 120
	},
	{
		title: 'BC',
		tooltip: 'Beauty Consultant',
		prop: 'beautyConsultant',
		sortable: true,
		component: 'ProjectTableText',
		width: 60
	},
	{
		title: 'Contact',
		prop: 'contactEmail',
		component: 'ProjectTableText',
		sortable: true,
		width: 160
	},
	{
		title: 'Personalization',
		prop: 'typeOfProject.personalization',
		component: 'ProjectTableText',
		sortable: true,
		width: 160
	},
	{
		title: 'Open/Refurb',
		prop: 'parent',
		component: 'ProjectTableText',
		sortable: true,
		width: 140
	},
	{
		title: 'Age',
		prop: 'age',
		component: 'ProjectTableText',
		width: 120,
		sortable: true,
		unit: 'years'
	},
	{
		title: 'Closure date',
		prop: 'closureDate',
		component: 'ProjectTableDateText',
		width: 120,
		sortable: true
	}
]

export const pagination = {
	itemPerPage: 30
}

export const pptxConfig = {
	layout: {
		name: 'SHISEIDO'
	},
	content: [
		// slide 1
		{
			background: 'slide1/background.png.b64.txt',
			images: [
				{
					file: 'slide1/shiseido.png.b64.txt',
					x: 11.78,
					y: 13.32,
					h: 0.39,
					w: 2.18,
				},
				{
					file: 'slide1/issey_miyake.png.b64.txt',
					x: 15.03,
					y: 0.57,
					h: 8.56,
					w: 8.56,
				},
				{
					file: 'slide1/narciso_rodriguez.png.b64.txt',
					x: 16.28,
					y: 6.47,
					h: 0.47,
					w: 6.07,
				},
				{
					file: 'slide1/zadig_voltaire.png.b64.txt',
					x: 16.74,
					y: 7.21,
					h: 2.9,
					w: 5.15,
				},
			],
			texts: [
				{
					align: 'left',
					fontSize: 42,
					fontFace: 'Questrial',
					text: 'DESIGNER FRAGRANCE BRANDS',
					x: 1.25,
					y: 2.19,
					h: 4.09,
					w: 13.6,
				},
				{
					align: 'left',
					color: 'ca1b30',
					fontSize: 15,
					fontFace: 'Figtree',
					text: 'POS PLATFORM REPORTING',
					lineSpacingMultiple: 1.15,
					x: 1.25,
					y: 7.08,
					h: 1.82,
					w: 6.07,
				},
			]
		},
		// slide 2
		{
			background: 'slide2/background.png.b64.txt',
			texts: [
				{
					align: 'left',
					bold: true,
					fontSize: 31,
					fontFace: 'Questrial',
					text: 'Reporting scope',
					x: 2,
					y: 1.24,
					h: 1.59,
					w: 21.4,
				},
				{
					align: 'left',
					bold: true,
					color: 'ca1b30',
					fontSize: 10,
					fontFace: 'Questrial',
					text: '{{ filtered.installationDate }}',
					x: 2.06,
					y: 2.95,
					h: 0.68,
					w: 5.72,
				},
				// {
				// 	align: 'left',
				// 	fontSize: 10,
				// 	fontFace: 'Questrial',
				// 	highlight: 'c8f0b9',
				// 	text: '{{ filtered.dateOfRequest }}',
				// 	x: 2.06,
				// 	y: 2.95,
				// 	h: 0.68,
				// 	w: 8,
				// },
				{
					align: 'center',
					bold: true,
					fontSize: 21,
					fontFace: 'Questrial',
					text: '01',
					x: 2,
					y: 3.95,
					h: 1.35,
					w: 2.04,
				},
				{
					align: 'left',
					fontSize: 21,
					fontFace: 'Questrial',
					text: 'Brands',
					x: 4.42,
					y: 3.95,
					h: 1.35,
					w: 6.4,
				},
				{
					align: 'left',
					color: 'ca1b30',
					fontSize: 14,
					fontFace: 'Figtree',
					text: '{{ filtered.brand }}',
					x: 4.4,
					y: 4.97,
					h: 1.59,
					valign: 'top',
					w: 6.4,
				},
				{
					align: 'center',
					bold: true,
					fontSize: 21,
					fontFace: 'Questrial',
					text: '02',
					x: 2,
					y: 7.02,
					h: 1.35,
					valign: 'bottom',
					w: 2.04,
				},
				{
					align: 'left',
					fontSize: 21,
					fontFace: 'Questrial',
					text: 'Distribution channel',
					x: 4.42,
					y: 7.02,
					h: 1.35,
					w: 7.26,
				},
				{
					align: 'left',
					color: 'ca1b30',
					fontSize: 14,
					fontFace: 'Figtree',
					text: '{{ filtered.distributionChannel }}',
					x: 4.42,
					y: 8.04,
					h: 1.59,
					valign: 'top',
					w: 6.4,
				},
				{
					align: 'center',
					bold: true,
					fontSize: 21,
					fontFace: 'Questrial',
					text: '03',
					x: 2,
					y: 10.09,
					h: 1.35,
					valign: 'bottom',
					w: 2.04,
				},
				{
					align: 'left',
					fontSize: 21,
					fontFace: 'Questrial',
					text: 'Area',
					x: 4.42,
					y: 10.09,
					h: 1.35,
					w: 6.4,
				},
				{
					align: 'left',
					color: 'ca1b30',
					fontSize: 14,
					fontFace: 'Figtree',
					text: '{{ filtered.area }}',
					x: 4.42,
					y: 11.1,
					h: 1.59,
					valign: 'top',
					w: 6.4,
				},
				{
					align: 'center',
					bold: true,
					fontSize: 21,
					fontFace: 'Questrial',
					text: '04',
					x: 12.42,
					y: 3.95,
					h: 1.35,
					valign: 'bottom',
					w: 2.04,
				},
				{
					align: 'left',
					fontSize: 21,
					fontFace: 'Questrial',
					text: 'Type of project',
					x: 14.85,
					y: 3.95,
					h: 1.35,
					w: 6.4,
				},
				{
					align: 'left',
					color: 'ca1b30',
					fontSize: 14,
					fontFace: 'Figtree',
					text: '{{ filtered.typeOfProjectType }}',
					x: 14.84,
					y: 4.97,
					h: 1.59,
					valign: 'top',
					w: 6.4,
				},
				{
					align: 'center',
					bold: true,
					fontSize: 21,
					fontFace: 'Questrial',
					text: '05',
					x: 12.42,
					y: 7.02,
					h: 1.35,
					valign: 'bottom',
					w: 2.04,
				},
				{
					align: 'left',
					fontSize: 21,
					fontFace: 'Questrial',
					text: 'Type of store',
					x: 14.85,
					y: 7.02,
					h: 1.35,
					w: 6.4,
				},
				{
					align: 'left',
					color: 'ca1b30',
					fontSize: 14,
					fontFace: 'Figtree',
					text: '{{ filtered.typeOfStore }}',
					x: 14.84,
					y: 8.04,
					h: 1.59,
					valign: 'top',
					w: 6.4,
				},
			]
		},
		// slide 3
		{
			background: 'slide3/background.png.b64.txt',
			images: [
				{
					file: 'slide3/icon1.png.b64.txt',
					x: 2.45,
					y: 4.51,
					h: 2.3,
					w: 2.3,
				},
				{
					file: 'slide3/icon2.png.b64.txt',
					x: 13.59,
					y: 4.51,
					h: 2.3,
					w: 2.3,
				},
				{
					file: 'slide3/icon3.png.b64.txt',
					x: 2.45,
					y: 9.58,
					h: 2.3,
					w: 2.3,
				},
				{
					file: 'slide3/icon4.png.b64.txt',
					x: 13.59,
					y: 9.58,
					h: 2.3,
					w: 2.3,
				},
			],
			texts: [
				{
					align: 'center',
					bold: true,
					fontSize: 31,
					fontFace: 'Questrial',
					text: 'Summary',
					x: 2,
					y: 1.24,
					h: 1.59,
					w: 21.4,
				},
				{
					align: 'left',
					color: 'ca1b30',
					fontSize: 21,
					fontFace: 'Questrial',
					text: '{{ data.pos.fullPeriod.total }} POS',
					x: 5.39,
					y: 4.52,
					h: 1.35,
					w: 6.4,
				},
				{
					align: 'left',
					fontSize: 14,
					fontFace: 'Figtree',
					text: [
						{ text: '{{ data.pos.fullPeriod.local }}', options: { bold: true, color: 'ca1b30' } },
						{ text: ' Local markets,\n' },
						{ text: '{{ data.pos.fullPeriod.travel }}', options: { bold: true, color: 'ca1b30' } },
						{ text: ' Travel retail,\n' },
						{ text: 'Included ' },
						{ text: '{{ data.pos.fullPeriod.musc }}', options: { bold: true, color: 'ca1b30' } },
						{ text: ' Musc Co \n' },
					],
					x: 5.39,
					y: 5.53,
					h: 2.3,
					valign: 'top',
					w: 6.13,
				},
				{
					align: 'left',
					color: 'ca1b30',
					fontSize: 21,
					fontFace: 'Questrial',
					text: 'Stores types',
					x: 16.52,
					y: 4.52,
					h: 1.35,
					w: 5.5,
				},
				{
					align: 'left',
					fontSize: 14,
					fontFace: 'Figtree',
					text: [
						{ text: 'Perfumeries ' },
						{ text: '{{ data.typeOfStore.fullPeriod.perfumes.percent }}%\n', options: { bold: true, color: 'ca1b30' } },
						{ text: 'Department stores ' },
						{ text: '{{ data.typeOfStore.fullPeriod.department.percent }}%\n', options: { bold: true, color: 'ca1b30' } },
						{ text: 'Duty free ' },
						{ text: '{{ data.typeOfStore.fullPeriod.dutyFree.percent }}%', options: { bold: true, color: 'ca1b30' } },
					],
					x: 16.52,
					y: 5.53,
					h: 1.85,
					valign: 'top',
					w: 8.28,
				},
				{
					align: 'left',
					color: 'ca1b30',
					fontSize: 21,
					fontFace: 'Questrial',
					text: 'Top regions',
					x: 5.39,
					y: 9.58,
					h: 1.35,
					w: 5.5,
				},
				{
					align: 'left',
					fontSize: 14,
					fontFace: 'Figtree',
					text: '{{ data.area.fullPeriod }}',
					x: 5.39,
					y: 10.59,
					h: 1.85,
					valign: 'top',
					w: 5.61,
				},
				{
					align: 'left',
					color: 'ca1b30',
					fontSize: 21,
					fontFace: 'Questrial',
					text: 'Projects types',
					x: 16.52,
					y: 9.58,
					h: 1.35,
					w: 5.5,
				},
				{
					align: 'left',
					fontSize: 14,
					fontFace: 'Figtree',
					text: [
						{ text: 'Personalization ' },
						{ text: '{{ data.personalisation.fullPeriod.full.percent }}%\n', options: { bold: true, color: 'ca1b30' } },
						{ text: 'Semi-personalization ' },
						{ text: '{{ data.personalisation.fullPeriod.semi.percent }}%', options: { bold: true, color: 'ca1b30' } },
					],
					x: 16.52,
					y: 10.59,
					h: 2.3,
					valign: 'top',
					w: 6.13,
				},
			]
		},
		// slide 4
		{
			background: 'slide4/background.png.b64.txt',
			images: [
				{
					file: 'slide4/map.png.b64.txt',
					x: 5.09,
					y: 3.39,
					h: 8.31,
					w: 15.22,
				},
				{
					file: 'slide4/icon1.png.b64.txt',
					x: 8.11,
					y: 7.26,
					h: 0.86,
					w: 0.86,
				},
				{
					file: 'slide4/icon1.png.b64.txt',
					x: 12.38,
					y: 5.8,
					h: 0.86,
					w: 0.86,
				},
				{
					file: 'slide4/icon1.png.b64.txt',
					x: 16.12,
					y: 7.92,
					h: 0.86,
					w: 0.86,
				},
				{
					file: 'slide4/icon2.png.b64.txt',
					x: 3.68,
					y: 9.83,
					h: 1.07,
					w: 1.07,
				},
				{
					file: 'slide4/icon2.png.b64.txt',
					x: 20.65,
					y: 9.83,
					h: 1.07,
					w: 1.07,
				},
				{
					file: 'slide4/icon2.png.b64.txt',
					x: 11.55,
					y: 11.26,
					h: 1.07,
					w: 1.07,
				},
				{
					file: 'slide4/trait.png.b64.txt',
					x: 5.72,
					y: 7.69,
					h: 0.06,
					w: 2.39,
				},
				{
					file: 'slide4/trait.png.b64.txt',
					x: 13.24,
					y: 6.24,
					h: 0.06,
					w: 2.39,
				},
				{
					file: 'slide4/trait.png.b64.txt',
					x: 16.98,
					y: 8.35,
					h: 0.06,
					w: 2.39,
				},
			],
			texts: [
				{
					align: 'left',
					bold: true,
					fontSize: 31,
					fontFace: 'Questrial',
					text: 'A worldwide presence',
					x: 2,
					y: 1.24,
					h: 1.59,
					w: 21.4,
				},
				{
					align: 'left',
					fontSize: 14,
					fontFace: 'Questrial',
					margin: [7, 7, 0, 3],
					text: [
						{ text: 'Americas\n' },
						{ text: '{{ data.pos.fullPeriod.americas }} POS\n', options: { color: 'ffffff', highlight: 'ca1b30' } },
					],
					x: 2.96,
					y: 7.26,
					h: 1.37,
					valign: 'top',
					w: 2.74,
				},
				{
					align: 'left',
					fontSize: 14,
					fontFace: 'Questrial',
					margin: [7, 7, 0, 3],
					text: [
						{ text: 'TR Americas\n' },
						{ text: '{{ data.pos.fullPeriod.tramericas }}  POS\n', options: { color: 'ffffff', highlight: 'ca1b30' } },
					],
					x: 4.75,
					y: 9.65,
					h: 1.37,
					valign: 'top',
					w: 3.36,
				},
				{
					align: 'left',
					fontSize: 14,
					fontFace: 'Questrial',
					margin: [7, 7, 0, 3],
					text: [
						{ text: 'TR EMEA\n' },
						{ text: '{{ data.pos.fullPeriod.tremea }} POS\n', options: { color: 'ffffff', highlight: 'ca1b30' } },
					],
					x: 12.62,
					y: 11.08,
					h: 1.37,
					valign: 'top',
					w: 2.57,
				},
				{
					align: 'left',
					fontSize: 14,
					fontFace: 'Questrial',
					margin: [7, 7, 0, 3],
					text: [
						{ text: 'EMEA ' },
						{ text: '{{ data.pos.fullPeriod.emea+export }} POS\n', options: { color: 'ffffff', highlight: 'ca1b30', fontSize: 12 } },
						{ text: '{{ data.pos.fullPeriod.emea }} AFFILIATES\n', options: { color: 'ca1b30', fontSize: 12 } },
						{ text: '{{ data.pos.fullPeriod.export }} EXPORT\n', options: { color: 'ca1b30', fontSize: 12 } },
					],
					x: 15.63,
					y: 5.8,
					h: 1.88,
					valign: 'top',
					w: 4.61,
				},
				{
					align: 'left',
					fontSize: 14,
					fontFace: 'Questrial',
					margin: [7, 7, 0, 3],
					text: [
						{ text: 'APAC\n' },
						{ text: '{{ data.pos.fullPeriod.apac }} POS\n', options: { color: 'ffffff', highlight: 'ca1b30' } },
					],
					x: 19.37,
					y: 7.92,
					h: 1.37,
					valign: 'top',
					w: 2.92,
				},
				{
					align: 'left',
					fontSize: 14,
					fontFace: 'Questrial',
					margin: [7, 7, 0, 3],
					text: [
						{ text: 'TR ASIA\n' },
						{ text: '{{ data.pos.fullPeriod.trasia }} POS\n', options: { color: 'ffffff', highlight: 'ca1b30' } },
					],
					x: 21.72,
					y: 9.65,
					h: 1.37,
					valign: 'top',
					w: 2.32,
				},
			]
		},
		// slide 5
		{
			background: 'slide5/background.png.b64.txt',
			datatype: 'groupProjectsByAreaAndCountry.1',
			datatables: [
				{
					rows: [
						[
							{ text: 'Area', options: { align: 'center', color: 'ffffff', fill: 'c00000', margin: 7, valign: 'middle' } },
							{ text: 'Country', options: { align: 'center', color: 'ffffff', fill: 'c00000', margin: 7, valign: 'middle' } },
							{ text: 'POS', options: { align: 'center', color: 'ffffff', fill: 'c00000', margin: 7, valign: 'middle' } },
						],
					],
					// autoPage: true,
					// autoPageRepeatHeader: true,
					border: { pt: 1, color: '000000' },
					colW: [1.9, 2.5, 4.83, 1.57],
					fontSize: 9,
					fontFace: 'Questrial',
					x: 1.73,
					y: 1.72,
					// h: 11.45,
					w: 21.95,
				}
			],
			texts: [
				{
					align: 'center',
					bold: true,
					fontSize: 31,
					fontFace: 'Questrial',
					text: 'Projects by Area & Countries - Local Market',
					x: 0,
					y: -0.27,
					h: 1.75,
					w: 25.4,
				},
			],
		},
		// slide 6
		{
			background: 'slide6/background.png.b64.txt',
			datatype: 'groupProjectsByAreaAndCountry.2',
			datatables: [
				{
					rows: [
						[
							{ text: 'Area', options: { align: 'center', color: 'ffffff', fill: 'c00000', margin: 7, valign: 'middle' } },
							{ text: 'Country', options: { align: 'center', color: 'ffffff', fill: 'c00000', margin: 7, valign: 'middle' } },
							{ text: 'POS', options: { align: 'center', color: 'ffffff', fill: 'c00000', margin: 7, valign: 'middle' } },
						],
					],
					border: { pt: 1, color: '000000' },
					colW: [1.9, 2.5, 4.83, 1.57],
					fontSize: 9,
					fontFace: 'Questrial',
					x: 1.73,
					y: 1.72,
					// h: 11.45,
					w: 21.95,
				},
			],
			texts: [
				{
					align: 'center',
					bold: true,
					fontSize: 31,
					fontFace: 'Questrial',
					text: 'Projects by Area & Countries - Travel Retail',
					x: 0,
					y: -0.27,
					h: 1.75,
					w: 25.4,
				},
			],
		},
		// slide 8
		{
			background: 'slide8/background.png.b64.txt',
			images: [
				{
					file: 'slide8/icon1.png.b64.txt',
					x: 3.8,
					y: 4.16,
					h: 3.07,
					w: 3.07,
				},
				{
					file: 'slide8/icon2.png.b64.txt',
					x: 13.85,
					y: 4.16,
					h: 3.07,
					w: 3.07,
				},
			],
			texts: [
				{
					align: 'left',
					bold: true,
					fontSize: 31,
					fontFace: 'Questrial',
					text: [
						{ text: 'Projects type ' }
					],
					x: 2,
					y: 1.24,
					h: 1.59,
					w: 21.4,
				},
				{
					align: 'left',
					bold: true,
					color: 'c00000',
					fontSize: 24,
					fontFace: 'Questrial',
					text: '{{ data.personalisation.fullPeriod.full.percent }}%',
					x: 3.8,
					y: 8.15,
					h: 1.13,
					valign: 'bottom',
					w: 2.82,
				},
				{
					align: 'left',
					fontSize: 21,
					fontFace: 'Questrial',
					text: 'Fully personalized',
					x: 3.8,
					y: 9.03,
					h: 1.4,
					w: 8.5,
				},
				{
					align: 'left',
					fontSize: 14,
					fontFace: 'Figtree',
					text: [
						{ text: 'Fully customized projects account for ' },
						{ text: '{{ data.personalisation.fullPeriod.full.percent }}%', options: { color: 'c00000' } },
						{ text: ' of requests, ' },
						{ text: '{{ data.personalisation.fullPeriod.full.value }} stores', options: { bold: true, color: 'c00000' } },
						{ text: ' in all.' },
					],
					x: 3.8,
					y: 10.29,
					h: 1.4,
					w: 7.8,
				},
				{
					align: 'left',
					bold: true,
					color: 'c00000',
					fontSize: 24,
					fontFace: 'Questrial',
					text: '{{ data.personalisation.fullPeriod.semi.percent }}%',
					x: 13.85,
					y: 8.15,
					h: 1.13,
					valign: 'bottom',
					w: 2.82,
				},
				{
					align: 'left',
					fontSize: 21,
					fontFace: 'Questrial',
					text: 'Semi-personalized',
					x: 13.85,
					y: 9.03,
					h: 1.4,
					w: 8.5,
				},
				{
					align: 'left',
					fontSize: 14,
					fontFace: 'Figtree',
					text: [
						{ text: 'Semi-personalized projects account for only ' },
						{ text: '{{ data.personalisation.fullPeriod.semi.percent }}%', options: { color: 'c00000' } },
						{ text: ' of requests, ' },
						{ text: '{{ data.personalisation.fullPeriod.semi.value }} stores', options: { bold: true, color: 'c00000' } },
						{ text: ' in all.' },
					],
					x: 13.85,
					y: 10.29,
					h: 1.4,
					w: 8.5,
				},
			],
		},
		// slide 9
		{
			background: 'slide9/background.png.b64.txt',
			charts: [
				{
					chartColors: ['#e0bce5', '#957dac', '#d292bd'],
					data: 'typeOfStore',
					x: 11.05,
					y: 1.54,
					h: 8.84,
					w: 14.31,
					showLabel: true,
					showPercent: true,
					dataLabelPosition: 'ctr',
					dataLabelColor: 'F1F1F1',
					dataLabelFontSize: 10,
					showLegend: false
				}
			],
			images: [
				{
					file: 'slide9/color1.png.b64.txt',
					x: 3.81,
					y: 4.55,
					h: 0.39,
					w: 0.39,
				},
				{
					file: 'slide9/color2.png.b64.txt',
					x: 3.81,
					y: 6.65,
					h: 0.39,
					w: 0.39,
				},
				{
					file: 'slide9/color3.png.b64.txt',
					x: 3.81,
					y: 9.01,
					h: 0.39,
					w: 0.39,
				},
			],
			texts: [
				{
					align: 'left',
					bold: true,
					fontSize: 31,
					fontFace: 'Questrial',
					text: [
						{ text: 'Store types ' },
					],
					x: 2,
					y: 1.24,
					h: 1.59,
					w: 21.4,
				},
				{
					align: 'center',
					fontSize: 22,
					fontFace: 'Figtree',
					line: { width: '1', color: 'c00000' },
					text: [
						{ text: '{{ data.typeOfStore.fullPeriod.labelPlural_1 }} ', options: { bold: true } },
						{ text: 'account for ' },
						{ text: '{{ data.typeOfStore.fullPeriod.percent_1 }}%,\n', options: { bold: true, color: 'c00000' } },
						{ text: '{{ data.typeOfStore.fullPeriod.labelPlural_2 }} ', options: { bold: true } },
						{ text: 'for ' },
						{ text: '{{ data.typeOfStore.fullPeriod.percent_2 }}%\n', options: { bold: true, color: 'c00000' } },
						{ text: 'and ' },
						{ text: '{{ data.typeOfStore.fullPeriod.labelPlural_3 }} ', options: { bold: true } },
						{ text: 'for ' },
						{ text: '{{ data.typeOfStore.fullPeriod.percent_3 }}%.', options: { bold: true, color: 'c00000' } },
					],
					x: 5.99,
					y: 10.68,
					h: 3.08,
					w: 13.8,
				},
				{
					align: 'right',
					bold: true,
					fontSize: 21,
					fontFace: 'Questrial',
					text: '{{ data.typeOfStore.fullPeriod.value_1 }}',
					x: 1.45,
					y: 4.04,
					h: 1.35,
					valign: 'top',
					w: 2.15,
				},
				{
					align: 'left',
					fontFace: 'Questrial',
					text: [
						{ text: '{{ data.typeOfStore.fullPeriod.label_1 }}\n', options: { fontSize: 21 } },
						// { text: '{{ data.typeOfStore.fullPeriod.personalization_1 }}', options: { fontSize: 16 } }
					],
					x: 4.2,
					y: 4.04,
					h: 1.35,
					valign: 'top',
					w: 7.35,
				},
				{
					align: 'right',
					bold: true,
					fontSize: 21,
					fontFace: 'Questrial',
					text: '{{ data.typeOfStore.fullPeriod.value_2 }}',
					x: 1.45,
					y: 6.17,
					h: 1.35,
					valign: 'top',
					w: 2.15,
				},
				{
					align: 'left',
					fontFace: 'Questrial',
					text: [
						{ text: '{{ data.typeOfStore.fullPeriod.label_2 }}\n', options: { fontSize: 21 } },
						// { text: '{{ data.typeOfStore.fullPeriod.personalization_2 }}', options: { fontSize: 16 } }
					],
					x: 4.2,
					y: 6.17,
					h: 1.35,
					valign: 'top',
					w: 7.35,
				},
				{
					align: 'right',
					bold: true,
					fontSize: 21,
					fontFace: 'Questrial',
					text: '{{ data.typeOfStore.fullPeriod.value_3 }}',
					x: 1.45,
					y: 8.5,
					h: 1.35,
					valign: 'top',
					w: 2.15,
				},
				{
					align: 'left',
					fontFace: 'Questrial',
					fontSize: 21,
					text: [
						{ text: '{{ data.typeOfStore.fullPeriod.label_3 }}\n', options: { fontSize: 21 } },
						// { text: '{{ data.typeOfStore.fullPeriod.personalization_3 }}', options: { fontSize: 16 } }
					],
					x: 4.2,
					y: 8.5,
					h: 1.35,
					valign: 'top',
					w: 7.35,
				},
			],
		},
		// slide 10
		{
			background: 'slide10/background.png.b64.txt',
			datatype: 'furnitures',
			datatables: [
				{
					rows: [
						[
							{ text: '' },
							{ text: 'IM', options: { align: 'center', bold: true, color: 'ffffff', fill: 'c00000', margin: 7, valign: 'middle' } },
							{ text: 'NR', options: { align: 'center', bold: true, color: 'ffffff', fill: 'c00000', margin: 7, valign: 'middle' } },
							{ text: 'ZV', options: { align: 'center', bold: true, color: 'ffffff', fill: 'c00000', margin: 7, valign: 'middle' } },
							{ text: 'Total across brands', options: { align: 'center', bold: true, color: '000000', fill: 'dddddd', margin: 7, valign: 'middle' } },
						],
						[
							{ text: 'Backwall', options: { align: 'center', bold: true, color: 'ffffff', fill: 'c00000', margin: 7, valign: 'middle' } },
							{ text: '{{ data.furnitures.backwall.im }}', options: { align: 'center', bold: true, valign: 'middle' } },
							{ text: '{{ data.furnitures.backwall.nr }}', options: { align: 'center', bold: true, valign: 'middle' } },
							{ text: '{{ data.furnitures.backwall.zv }}', options: { align: 'center', bold: true, valign: 'middle' } },
							{ text: '{{ data.furnitures.backwall.total }}', options: { align: 'center', bold: true, color: '000000', fill: 'dddddd', margin: 7, valign: 'middle' } },
						],
						[
							{ text: 'Counter', options: { align: 'center', bold: true, color: 'ffffff', fill: 'c00000', margin: 7, valign: 'middle' } },
							{ text: '{{ data.furnitures.counter.im }}', options: { align: 'center', bold: true, valign: 'middle' } },
							{ text: '{{ data.furnitures.counter.nr }}', options: { align: 'center', bold: true, valign: 'middle' } },
							{ text: '{{ data.furnitures.counter.zv }}', options: { align: 'center', bold: true, valign: 'middle' } },
							{ text: '{{ data.furnitures.counter.total }}', options: { align: 'center', bold: true, color: '000000', fill: 'dddddd', margin: 7, valign: 'middle' } },
						],
						[
							{ text: 'Gondola', options: { align: 'center', bold: true, color: 'ffffff', fill: 'c00000', margin: 7, valign: 'middle' } },
							{ text: '{{ data.furnitures.gondola.im }}', options: { align: 'center', bold: true, valign: 'middle' } },
							{ text: '{{ data.furnitures.gondola.nr }}', options: { align: 'center', bold: true, valign: 'middle' } },
							{ text: '{{ data.furnitures.gondola.zv }}', options: { align: 'center', bold: true, valign: 'middle' } },
							{ text: '{{ data.furnitures.gondola.total }}', options: { align: 'center', bold: true, color: '000000', fill: 'dddddd', margin: 7, valign: 'middle' } },
						],
						[
							{ text: 'Total POS units', options: { align: 'center', bold: true, color: '000000', fill: 'dddddd', margin: 7, valign: 'middle' } },
							{ text: '{{ data.furnitures.total.im }}', options: { align: 'center', bold: true, color: '000000', fill: 'dddddd', valign: 'middle' } },
							{ text: '{{ data.furnitures.total.nr }}', options: { align: 'center', bold: true, color: '000000', fill: 'dddddd', valign: 'middle' } },
							{ text: '{{ data.furnitures.total.zv }}', options: { align: 'center', bold: true, color: '000000', fill: 'dddddd', valign: 'middle' } },
							{ text: '{{ data.furnitures.total.total }}', options: { align: 'center', bold: true, color: '000000', fill: 'dddddd', margin: 7, valign: 'middle' } },
						],
					],
					// autoPage: true,
					// autoPageRepeatHeader: true,
					// border: { pt: 1, color: '000000' },
					colW: [1.9, 2.5, 4.83, 1.57],
					fontSize: 9,
					fontFace: 'Questrial',
					x: 1.73,
					y: 2.8,
					h: 5.42,
					w: 19.33,
				}
			],
			texts: [
				{
					align: 'left',
					bold: true,
					fontSize: 31,
					fontFace: 'Questrial',
					text: [
						{ text: 'Permanent POS Furniture Overview -' },
						{ text: ' {{ areaName }}', options: { color: 'c00000' } },
					],
					x: 1.73,
					y: 0.36,
					h: 1.75,
					w: 25.4,
				},
				{
					align: 'left',
					fontSize: 18,
					fontFace: 'Figtree',
					text: [
						{ text: 'Leading brand by installation volume: ' },
						{ text: '{{ data.furnitures.topBrand.label }} ', options: { bold: true, color: 'c00000' } },
						{ text: '- ' },
						{ text: '{{ data.furnitures.topBrand.value }}\n', options: { bold: true, color: 'c00000' } },
						{ text: 'Most deployed POS structure: ' },
						{ text: '{{ data.furnitures.topFurniture.label }} ', options: { bold: true, color: 'c00000' } },
						{ text: '- ' },
						{ text: '{{ data.furnitures.topFurniture.value }}', options: { bold: true, color: 'c00000' } },
					],
					x: 1.73,
					y: 9.07,
					h: 1.8,
					w: 19.75,
				},
			],
		},
		// slide 11
		{
			background: 'slide11/background.png.b64.txt',
			texts: [
				{
					align: 'left',
					bold: true,
					fontSize: 31,
					fontFace: 'Questrial',
					text: [
						{ text: 'Comparative Insights – ' },
						{ text: 'PY', options: { color: 'c00000' } },
						{ text: ' vs ' },
						{ text: 'YTD', options: { color: 'c00000' } },
					],
					x: 2,
					y: 0.92,
					h: 2.14,
					w: 21.4,
				},
				{
					align: 'left',
					color: 'c00000',
					fontSize: 21,
					fontFace: 'Questrial',
					text: 'POS Growth',
					x: 2.19,
					y: 3.59,
					h: 1.35,
					w: 6.03,
				},
				{
					align: 'left',
					fontSize: 14,
					fontFace: 'Figtree',
					valign: 'top',
					text: [
						{ text: '{{ data.pos.priorYear.total }} POS ', options: { bold: true } },
						{ text: '(PY)\n' },
						{ text: '{{ data.pos.fullPeriod.total }} POS ', options: { bold: true } },
						{ text: '(YTD)\n' },
						{ text: '{{ data.diff.pos.total }}', options: { bold: true, color: 'c00000' } },
					],
					x: 2.19,
					y: 4.6,
					h: 1.85,
					w: 6.04,
				},
				{
					align: 'left',
					color: 'c00000',
					fontSize: 21,
					fontFace: 'Questrial',
					text: 'Personalization',
					x: 8.97,
					y: 3.59,
					h: 1.35,
					w: 6.03,
				},
				{
					align: 'left',
					fontSize: 14,
					fontFace: 'Figtree',
					valign: 'top',
					text: [
						{ text: 'Stable high levels\n' },
						{ text: 'PY: {{ data.personalisation.priorYear.full.percent }}%', options: { bold: true } },
						{ text: ' full perso - ' },
						{ text: '{{ data.personalisation.priorYear.semi.percent }}% ', options: { bold: true } },
						{ text: 'semi\n' },
						{ text: 'YTD: {{ data.personalisation.fullPeriod.full.percent }}%', options: { bold: true } },
						{ text: ' full perso - ' },
						{ text: '{{ data.personalisation.fullPeriod.semi.percent }}% ', options: { bold: true } },
						{ text: 'semi' },
					],
					x: 8.97,
					y: 4.6,
					h: 1.85,
					w: 7.48,
				},
				{
					align: 'left',
					color: 'c00000',
					fontSize: 21,
					fontFace: 'Questrial',
					text: 'Countries evolution',
					x: 16.99,
					y: 3.59,
					h: 1.35,
					w: 7.11,
				},
				{
					align: 'left',
					fontSize: 14,
					fontFace: 'Figtree',
					valign: 'top',
					text: [
						{ text: 'PY: ', options: { bold: true } },
						{ text: '{{ data.country.priorYear }}\n' },
						{ text: 'YTD: ', options: { bold: true } },
						{ text: '{{ data.country.fullPeriod }}' },
					],
					x: 16.99,
					y: 4.6,
					h: 3.85,
					w: 6.05,
				},
				{
					align: 'left',
					color: 'c00000',
					fontSize: 21,
					fontFace: 'Questrial',
					text: 'Store Mix Shift',
					x: 2.19,
					y: 7.9,
					h: 1.35,
					w: 6.03,
				},
				{
					align: 'left',
					fontSize: 14,
					fontFace: 'Figtree',
					valign: 'top',
					text: [
						{ text: 'PY: ', options: { bold: true } },
						{ text: '{{ data.typeOfStore.priorYear.labelSmall_1 }} ' },
						{ text: '{{ data.typeOfStore.priorYear.value_1 }}%, ', options: { bold: true } },
						{ text: '{{ data.typeOfStore.priorYear.labelSmall_2 }} ' },
						{ text: '{{ data.typeOfStore.priorYear.value_2 }}%, ', options: { bold: true } },
						{ text: '{{ data.typeOfStore.priorYear.labelSmall_3 }} ' },
						{ text: '{{ data.typeOfStore.priorYear.value_2 }}%\n', options: { bold: true } },
						{ text: 'YTD: ', options: { bold: true } },
						{ text: '{{ data.typeOfStore.fullPeriod.labelSmall_1 }} ' },
						{ text: '{{ data.typeOfStore.fullPeriod.value_1 }}%, ', options: { bold: true } },
						{ text: '{{ data.typeOfStore.fullPeriod.labelSmall_2 }} ' },
						{ text: '{{ data.typeOfStore.fullPeriod.value_2 }}%, ', options: { bold: true } },
						{ text: '{{ data.typeOfStore.fullPeriod.labelSmall_3 }} ' },
						{ text: '{{ data.typeOfStore.fullPeriod.value_3 }}%', options: { bold: true } },
					],
					x: 2.19,
					y: 8.87,
					h: 3.85,
					w: 6.05,
				},
				{
					align: 'left',
					color: 'c00000',
					fontSize: 21,
					fontFace: 'Questrial',
					text: 'Regional Dynamics',
					x: 8.97,
					y: 7.9,
					h: 1.35,
					w: 6.96,
				},
				{
					align: 'left',
					fontSize: 14,
					fontFace: 'Figtree',
					valign: 'top',
					text: [
						{ text: '{{ data.topArea.0.label }}: ', options: { bold: true } },
						{ text: '{{ data.topArea.0.value.priorYear }} → {{ data.topArea.0.value.fullPeriod }} POS (' },
						{ text: '{{ data.topArea.0.diff }}', options: { bold: true, color: 'c00000' } },
						{ text: ')\n' },
						{ text: '{{ data.topArea.1.label }}: ', options: { bold: true } },
						{ text: '{{ data.topArea.1.value.priorYear }} → {{ data.topArea.1.value.fullPeriod }} POS (' },
						{ text: '{{ data.topArea.1.diff }}', options: { bold: true, color: 'c00000' } },
						{ text: ')\n' },
						{ text: '{{ data.topArea.2.label }}: ', options: { bold: true } },
						{ text: '{{ data.topArea.2.value.priorYear }} → {{ data.topArea.2.value.fullPeriod }} POS (' },
						{ text: '{{ data.topArea.2.diff }}', options: { bold: true, color: 'c00000' } },
						{ text: ')' },
					],
					x: 8.97,
					y: 8.87,
					h: 3.85,
					w: 7.48,
				},
				{
					align: 'center',
					fontSize: 11,
					fontFace: 'Figtree',
					italic: true,
					valign: 'top',
					text: [
						{ text: 'PY', options: { bold: true, color: 'c00000' } },
						{ text: ': Prior Year ({{ filtered.installationDate.priorYear }}) - ' },
						{ text: 'YTD', options: { bold: true, color: 'c00000' } },
						{ text: ': Year-to-Date ({{ filtered.installationDate }})' },
					],
					x: 3.2,
					y: 13.37,
					h: 1.35,
					w: 19,
				},
			]
		},
		// slide 12
		{
			background: 'slide12/background.png.b64.txt',
			images: [
				{
					file: 'slide12/icon1.png.b64.txt',
					x: 7.39,
					y: 3.43,
					h: 2.3,
					w: 2.3,
				},
				{
					file: 'slide12/icon2.png.b64.txt',
					x: 15.2,
					y: 3.43,
					h: 2.3,
					w: 2.3,
				},
			],
			texts: [
				{
					align: 'left',
					bold: true,
					fontSize: 31,
					fontFace: 'Questrial',
					text: [
						{ text: 'Top Regions & Countries – ' },
						{ text: 'PY', options: { color: 'c00000' } },
						{ text: ' vs ' },
						{ text: 'YTD', options: { color: 'c00000' } },
					],
					x: 2,
					y: 0.92,
					h: 2.14,
					w: 21.4,
				},
				{
					align: 'left',
					bold: true,
					fontSize: 21,
					fontFace: 'Questrial',
					text: 'Top Regions',
					x: 6.46,
					y: 6.21,
					h: 1.35,
					w: 7.36,
				},
				{
					align: 'center',
					bold: true,
					fontSize: 14,
					fontFace: 'Figtree',
					line: { width: '1', color: 'c00000' },
					text: 'PY',
					x: 2.42,
					y: 8.61,
					h: 0.85,
					w: 1.8,
				},
				{
					align: 'left',
					fontSize: 14,
					fontFace: 'Figtree',
					text: [
						{ text: '{{ data.topArea.0.label.priorYear }}: ', options: { bold: true } },
						{ text: '{{ data.topArea.0.value.priorYear }} POS\n' },
						{ text: '{{ data.topArea.1.label.priorYear }}: ', options: { bold: true } },
						{ text: '{{ data.topArea.1.value.priorYear }} POS\n' },
						{ text: '{{ data.topArea.2.label.priorYear }}: ', options: { bold: true } },
						{ text: '{{ data.topArea.2.value.priorYear }} POS' },
					],
					x: 6.46,
					y: 7.63,
					h: 2.81,
					w: 7.36,
				},
				{
					align: 'center',
					bold: true,
					fontSize: 14,
					fontFace: 'Figtree',
					line: { width: '1', color: 'c00000' },
					text: 'YTD',
					x: 2.42,
					y: 11.48,
					h: 0.85,
					w: 1.8,
				},
				{
					align: 'left',
					fontSize: 14,
					fontFace: 'Figtree',
					valign: 'top',
					text: [
						{ text: '{{ data.topArea.0.label.fullPeriod }}: ', options: { bold: true } },
						{ text: '{{ data.topArea.0.value.fullPeriod }} POS\n' },
						{ text: '{{ data.topArea.1.label.fullPeriod }}: ', options: { bold: true } },
						{ text: '{{ data.topArea.1.value.fullPeriod }} POS\n' },
						{ text: '{{ data.topArea.2.label.fullPeriod }}: ', options: { bold: true } },
						{ text: '{{ data.topArea.2.value.fullPeriod }} POS' },
					],
					x: 6.46,
					y: 10.75,
					h: 2.81,
					w: 7.36,
				},
				{
					align: 'left',
					bold: true,
					fontSize: 21,
					fontFace: 'Questrial',
					text: 'Top Countries',
					x: 13.82,
					y: 6.22,
					h: 1.35,
					w: 7.36,
				},
				{
					align: 'left',
					fontSize: 14,
					fontFace: 'Figtree',
					text: [
						{ text: '{{ data.topCountry.0.label.priorYear }}: ', options: { bold: true } },
						{ text: '{{ data.topCountry.0.value.priorYear }} POS\n' },
						{ text: '{{ data.topCountry.1.label.priorYear }}: ', options: { bold: true } },
						{ text: '{{ data.topCountry.1.value.priorYear }} POS\n' },
						{ text: '{{ data.topCountry.2.label.priorYear }}: ', options: { bold: true } },
						{ text: '{{ data.topCountry.2.value.priorYear }} POS' },
					],
					x: 13.82,
					y: 8.36,
					h: 1.35,
					w: 10.22,
				},
				{
					align: 'left',
					fontSize: 14,
					fontFace: 'Figtree',
					text: [
						{ text: '{{ data.topCountry.0.label.fullPeriod }}: ', options: { bold: true } },
						{ text: '{{ data.topCountry.0.value.fullPeriod }} POS\n' },
						{ text: '{{ data.topCountry.1.label.fullPeriod }}: ', options: { bold: true } },
						{ text: '{{ data.topCountry.1.value.fullPeriod }} POS\n' },
						{ text: '{{ data.topCountry.2.label.fullPeriod }}: ', options: { bold: true } },
						{ text: '{{ data.topCountry.2.value.fullPeriod }} POS' },
					],
					x: 13.82,
					y: 11.17,
					h: 1.35,
					w: 10.22,
				},
				{
					align: 'center',
					fontSize: 11,
					fontFace: 'Figtree',
					italic: true,
					valign: 'top',
					text: [
						{ text: 'PY', options: { bold: true, color: 'c00000' } },
						{ text: ': Prior Year ({{ filtered.installationDate.priorYear }}) - ' },
						{ text: 'YTD', options: { bold: true, color: 'c00000' } },
						{ text: ': Year-to-Date ({{ filtered.installationDate }})' },
					],
					x: 3.2,
					y: 13.37,
					h: 1.35,
					w: 19,
				},
			]
		},
		// slide 13
		{
			background: 'slide13/background.png.b64.txt',
			images: [
				{
					file: 'slide13/image1.png.b64.txt',
					x: 15.24,
					y: 2.79,
					h: 9.13,
					w: 8.99,
				},
			],
			texts: [
				{
					align: 'left',
					fontSize: 45,
					fontFace: 'Questrial',
					text: 'STORE DESIGN INSTALLATIONS',
					x: 1.02,
					y: 2.37,
					h: 3.82,
					w: 13.21,
				},
				{
					align: 'left',
					fontSize: 24,
					fontFace: 'Questrial',
					text: '{{ currentYear }}',
					x: 1.48,
					y: 7.61,
					h: 1.28,
					w: 16.09,
				},
			],
		}
	],
	icons: {
		map: 'image/png;base64,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',
		plane: 'image/png;base64,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'
	}
}

export const validationRulesCreate = {
	projectName: [{ required: true, message: 'Project name is required', trigger: 'blur' }],
	contactEmail: [{ required: true, message: 'Contact email is required', type: 'email', trigger: 'blur' }],
	dateOfRequest: [{ required: true, message: 'Date of request is required', type: 'date', trigger: 'blur' }],
	retailersSubmissionDate: [{ required: true, message: 'Retailer’s submission date is required', type: 'date', trigger: 'blur' }],
	installationDate: [{ required: true, message: 'Installation date is required', type: 'date', trigger: 'blur' }],
	// closureDate: [{ required: true, message: 'Closure date is required', type: 'date', trigger: 'blur' }],
	projectStatus: [{ required: true, message: 'Project Status is required', type: 'number', trigger: 'change' }],
	'projectBrands.0.value': [{ required: true, message: 'Select a priority for IM', type: 'number', trigger: 'blur' }],
	'projectBrands.1.value': [{ required: true, message: 'Select a priority for NR', type: 'number', trigger: 'blur' }],
	'projectBrands.2.value': [{ required: true, message: 'Select a priority for ES', type: 'number', trigger: 'blur' }],
	'projectBrands.3.value': [{ required: true, message: 'Select a priority for ZV', type: 'number', trigger: 'blur' }],
	distributionChannel: [{ required: true, message: 'Distribution Channel is required', type: 'number', trigger: 'change' }],
	area: [{ required: true, message: 'Area is required', type: 'number', trigger: 'change' }],
	country: [{ required: true, message: 'Country is required', type: 'number', trigger: 'change' }],
	city: [{ required: true, message: 'City is required', trigger: 'blur' }],
	retailerName: [{ required: true, message: 'Retailer name is required', trigger: 'blur' }],
	storeName: [{ required: true, message: 'Store name is required', trigger: 'blur' }],
	typeOfStore: [{ required: true, message: 'Type of store is required', type: 'number', trigger: 'change' }],
	annualTurnover: [{ required: true, message: 'Annual turnover expectations is required', type: 'number', trigger: 'change' }],
	beautyConsultant: [{ required: true, message: 'Beauty Consultant is required', trigger: 'change' }],
	budgetInK: [{ required: true, message: 'Budget is required', type: 'number', trigger: 'change' }],
	'typeOfProject.type': [{ required: true, message: 'You must select a value', type: 'number', trigger: 'change' }],
	'typeOfProject.personalization': [{ required: true, message: 'You must select a value' }],
	'typeOfProject.items': [{ required: true, message: 'You must select a value', type: 'array' }],
	dimensions: [{ required: true, message: 'Dimensions is required', type: 'number', trigger: 'blur' }],
	dimensionsUnit: [{ required: true, message: 'Dimensions unit is required', trigger: 'change' }],
	groupSpacePlans: [{ required: true, message: 'Group Space Plans is required' }],
	generalFloorPlans: [{ required: true, message: 'General Floor Plans is required' }],
	step: [{ required: true, message: 'Project Step is required' }],
	'projectSteps.0.date': [{ required: true, message: 'Date is required', type: 'date', trigger: 'blur' }],
	specificNeeds: [{ required: true, message: 'You must refer a need', type: 'array', trigger: 'change' }],
	'projectBrandCollections.0.value': [{ required: true, message: 'Please select Yes or No', trigger: 'change' }],
}

export const validationRulesEdition = {
	projectName: [{ required: true, message: 'Project name is required', trigger: 'blur' }],
	contactEmail: [{ required: true, message: 'Contact email is required', type: 'email', trigger: 'blur' }],
	dateOfRequest: [{ required: true, message: 'Date of request is required', type: 'date', trigger: 'blur' }],
	retailersSubmissionDate: [{ required: true, message: 'Retailer’s submission date is required', type: 'date', trigger: 'blur' }],
	installationDate: [{ required: true, message: 'Installation date is required', type: 'date', trigger: 'blur' }],
	// closureDate: [{ required: true, message: 'Closure date is required', type: 'date', trigger: 'blur' }],
	projectStatus: [{ required: true, message: 'Project Status is required', type: 'number', trigger: 'change' }],
	'projectBrands.0.value': [{ required: true, message: 'Select a priority for IM', type: 'number', trigger: 'blur' }],
	'projectBrands.1.value': [{ required: true, message: 'Select a priority for NR', type: 'number', trigger: 'blur' }],
	'projectBrands.2.value': [{ required: true, message: 'Select a priority for ES', type: 'number', trigger: 'blur' }],
	'projectBrands.3.value': [{ required: true, message: 'Select a priority for ZV', type: 'number', trigger: 'blur' }],
	distributionChannel: [{ required: true, message: 'Distribution Channel is required', type: 'number', trigger: 'change' }],
	area: [{ required: true, message: 'Area is required', type: 'number', trigger: 'change' }],
	country: [{ required: true, message: 'Country is required', type: 'number', trigger: 'change' }],
	city: [{ required: true, message: 'City is required', trigger: 'blur' }],
	retailerName: [{ required: true, message: 'Retailer name is required', trigger: 'blur' }],
	storeName: [{ required: true, message: 'Store name is required', trigger: 'blur' }],
	typeOfStore: [{ required: true, message: 'Type of store is required', type: 'number', trigger: 'change' }],
	annualTurnover: [{ required: true, message: 'Annual turnover expectations is required', type: 'number', trigger: 'change' }],
	beautyConsultant: [{ required: true, message: 'Beauty Consultant is required', trigger: 'change' }],
	budgetInK: [{ required: true, message: 'Budget is required', type: 'number', trigger: 'change' }],
	// supplierManufacturerEntity: [{ required: true, message: 'Supplier / Manufacturer is required', type: 'number', trigger: 'blur' }],
	'typeOfProject.type': [{ required: true, message: 'You must select a value', type: 'number', trigger: 'change' }],
	'typeOfProject.personalization': [{ required: true, message: 'You must select a value' }],
	'typeOfProject.items': [{ required: true, message: 'You must select a value', type: 'array' }],
	dimensions: [{ required: true, message: 'Dimensions is required', type: 'number', trigger: 'blur' }],
	dimensionsUnit: [{ required: true, message: 'Dimensions unit is required', trigger: 'change' }],
	groupSpacePlans: [{ required: true, message: 'Group Space Plans is required' }],
	generalFloorPlans: [{ required: true, message: 'General Floor Plans is required' }],
	step: [{ required: true, message: 'Project Step is required' }],
	'projectSteps.0.date': [{ required: true, message: 'Date is required', type: 'date', trigger: 'blur' }],
	specificNeeds: [{ required: true, message: 'You must refer a need', type: 'array', trigger: 'change' }],
	'projectBrandCollections.0.value': [{ required: true, message: 'Please select Yes or No', trigger: 'change' }],
}

export const validationRulesRefurbish = {
	projectName: [{ required: true, message: 'Project name is required', trigger: 'blur' }],
	contactEmail: [{ required: true, message: 'Contact email is required', type: 'email', trigger: 'blur' }],
	dateOfRequest: [{ required: true, message: 'Date of request is required', type: 'date', trigger: 'blur' }],
	retailersSubmissionDate: [{ required: true, message: 'Retailer’s submission date is required', type: 'date', trigger: 'blur' }],
	installationDate: [{ required: true, message: 'Installation date is required', type: 'date', trigger: 'blur' }],
	// closureDate: [{ required: true, message: 'Closure date is required', type: 'date', trigger: 'blur' }],
	projectStatus: [{ required: true, message: 'Project Status is required', type: 'number', trigger: 'change' }],
	'projectBrands.0.value': [{ required: true, message: 'Select a priority for IM', type: 'number', trigger: 'blur' }],
	'projectBrands.1.value': [{ required: true, message: 'Select a priority for NR', type: 'number', trigger: 'blur' }],
	'projectBrands.2.value': [{ required: true, message: 'Select a priority for ES', type: 'number', trigger: 'blur' }],
	'projectBrands.3.value': [{ required: true, message: 'Select a priority for ZV', type: 'number', trigger: 'blur' }],
	distributionChannel: [{ required: true, message: 'Distribution Channel is required', type: 'number', trigger: 'change' }],
	area: [{ required: true, message: 'Area is required', type: 'number', trigger: 'change' }],
	country: [{ required: true, message: 'Country is required', type: 'number', trigger: 'change' }],
	city: [{ required: true, message: 'City is required', trigger: 'blur' }],
	retailerName: [{ required: true, message: 'Retailer name is required', trigger: 'blur' }],
	storeName: [{ required: true, message: 'Store name is required', trigger: 'blur' }],
	typeOfStore: [{ required: true, message: 'Type of store is required', type: 'number', trigger: 'change' }],
	annualTurnover: [{ required: true, message: 'Annual turnover expectations is required', type: 'number', trigger: 'change' }],
	beautyConsultant: [{ required: true, message: 'Beauty Consultant is required', trigger: 'change' }],
	budgetInK: [{ required: true, message: 'Budget is required', type: 'number', trigger: 'change' }],
	'typeOfProject.type': [{ required: true, message: 'You must select a value', type: 'number', trigger: 'change' }],
	'typeOfProject.personalization': [{ required: true, message: 'You must select a value' }],
	'typeOfProject.items': [{ required: true, message: 'You must select a value', type: 'array' }],
	dimensions: [{ required: true, message: 'Dimensions is required', type: 'number', trigger: 'blur' }],
	dimensionsUnit: [{ required: true, message: 'Dimensions unit is required', trigger: 'change' }],
	groupSpacePlans: [{ required: true, message: 'Group Space Plans is required' }],
	generalFloorPlans: [{ required: true, message: 'General Floor Plans is required' }],
	step: [{ required: true, message: 'Project Step is required' }],
	'projectSteps.0.date': [{ required: true, message: 'Date is required', type: 'date', trigger: 'blur' }],
	// supplierManufacturerEntity: [{ required: true, message: 'Supplier / Manufacturer is required', type: 'number', trigger: 'blur' }],
	specificNeeds: [{ required: true, message: 'You must refer a need', type: 'array', trigger: 'change' }],
	'projectBrandCollections.0.value': [{ required: true, message: 'Please select Yes or No', trigger: 'change' }],
}

export const newProject = {
	id: 0,
	csrf_token: '',
	projectName: '',
	contactEmail: '',
	dateOfRequest: moment().format(),
	retailersSubmissionDate: '',
	installationDate: '',
	closureDate: '',
	avatarFile: {
		name: null,
		url: null
	},
	projectStatus: 5,
	projectBrands: [
		{
			value: 0,
			brandId: 1
		},
		{
			value: 0,
			brandId: 2
		},
		{
			value: 0,
			brandId: 3
		},
		{
			value: 0,
			brandId: 4
		}
	],
	projectBrandCollections: [
		{
			value: 0,
			brandCollectionId: 1
		}
	],
	distributionChannel: null,
	area: null,
	country: null,
	city: '',
	retailerName: '',
	storeName: '',
	typeOfStore: null,
	annualTurnover: null,
	beautyConsultant: null,
	specificNeeds: [],
	other: '',
	budgetInK: null,
	finalBudget: null,
	supplierManufacturer: '',
	supplierManufacturerEntity: null,
	typeOfProject: {
		type: null,
		personalization: '',
		items: []
	},
	dimensions: null,
	dimensionsUnit: 'm',
	projectPriorities: [
		{
			brandId: null,
			productLine: '',
		}
	],
	groupSpacePlans: [],
	generalFloorPlans: [],
	step: 1,
	projectSteps: [
		{
			status: null,
			date: moment().format(),
			files: [],
			stepId: 1,
			comment: ''
		},
		{
			status: null,
			date: null,
			files: [],
			stepId: 2,
			comment: ''
		},
		{
			status: null,
			date: null,
			files: [],
			stepId: 3,
			comment: ''
		},
		{
			status: null,
			date: null,
			files: [],
			stepId: 4,
			comment: ''
		},
		{
			status: null,
			date: null,
			files: [],
			stepId: 5,
			comment: ''
		},
		{
			status: null,
			date: null,
			files: [],
			stepId: 6,
			comment: ''
		},
		{
			status: null,
			date: null,
			files: [],
			stepId: 7,
			comment: ''
		},
		{
			status: null,
			date: null,
			files: [],
			stepId: 8,
			comment: ''
		}
	],
	validatedByRegionalProjectManagerDate: null,
	validatedByRegionalProjectManagerName: null,
}

export const fakePof = {
	id: 0,
	csrf_token: '',
	projectName: 'My Custom Shop',
	contactEmail: 'contact@email.com',
	dateOfRequest: moment().format(),
	retailersSubmissionDate: new Date(),
	installationDate: new Date(),
	closureDate: new Date(),
	avatarFile: {
		name: null,
		url: null
	},
	projectStatus: 5,
	projectBrands: [
		{
			value: 2,
			brandId: 1
		},
		{
			value: 0,
			brandId: 2
		},
		{
			value: 1,
			brandId: 3
		},
		{
			value: 0,
			brandId: 4
		}
	],
	distributionChannel: 1,
	area: 2,
	country: 10,
	city: 'Fakepolis',
	retailerName: 'My Retailer custom',
	storeName: 'My Custom Store',
	typeOfStore: 8,
	annualTurnover: 10,
	beautyConsultant: 'Yes',
	specificNeeds: [1, 2],
	other: '',
	budgetInK: 2,
	supplierManufacturer: 'My Supplier',
	supplierManufacturerEntity: 0,
	typeOfProject: {
		type: 1,
		personalization: 'semi',
		items: [1, 3]
	},
	dimensions: 35,
	dimensionsUnit: 'm',
	projectPriorities: [
		{
			brandId: 1,
			productLine: 'My product Line',
		}
	],
	groupSpacePlans: [1, 2, 4],
	generalFloorPlans: [1],
	step: 1,
	projectSteps: [
		{
			status: null,
			date: moment().format(),
			files: [],
			stepId: 1,
			comment: ''
		},
		{
			status: null,
			date: null,
			files: [],
			stepId: 2,
			comment: ''
		},
		{
			status: null,
			date: null,
			files: [],
			stepId: 3,
			comment: ''
		},
		{
			status: null,
			date: null,
			files: [],
			stepId: 4,
			comment: ''
		},
		{
			status: null,
			date: null,
			files: [],
			stepId: 5,
			comment: ''
		},
		{
			status: null,
			date: null,
			files: [],
			stepId: 6,
			comment: ''
		},
		{
			status: null,
			date: null,
			files: [],
			stepId: 7,
			comment: ''
		},
		{
			status: null,
			date: null,
			files: [],
			stepId: 8,
			comment: ''
		},
	]
}



// WEBPACK FOOTER //
// ./src/config.js